/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ScenicPage.vue?vue&type=template&id=c8fd61d0&scoped=true&"
import script from "./ScenicPage.vue?vue&type=script&lang=ts&"
export * from "./ScenicPage.vue?vue&type=script&lang=ts&"
import style0 from "./ScenicPage.vue?vue&type=style&index=0&id=c8fd61d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fd61d0",
  null
  
)

export default component.exports